<template>
  <div class="helpdesk-ticket-slot">
    <ticket-details v-if="ticketId" :id="ticketId" :key="ticketId" embedded />
    <div v-else class="text-muted p-2">No se encontró el ticket.</div>
  </div>
</template>

<script>
import TicketDetails from "@/views/helpdesk/tickets/TicketDetails.vue";

export default {
  components: {
    TicketDetails,
  },
  props: {
    ticket: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ticketId() {
      return this.ticket && this.ticket.data ? this.ticket.data.id : null;
    },
  },
};
</script>

<style scoped>
.helpdesk-ticket-slot {
  height: 100%;
  overflow-y: auto;
}
</style>
